export const SETTINGS = [
  { label: "Offers", value: "offer" },
  { label: "Content Review", value: "content_review" },
  { label: "Posts", value: "post" },
  { label: "Live Content Due", value: "live_content_due" },
  { label: "Connections", value: "connections" },
];
